import { Grid, TextField } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { BASE_URL } from "../App";
import { Theme, useTheme } from "@mui/material/styles";
import { useDrag, useDrop } from "react-dnd";
import { useEffect, useState } from "react";
import CustomDragLayer from "./DragPreview";
import { getEmptyImage } from "react-dnd-html5-backend";
import { MaterialGridItem } from "../../../dist/utils/reco/material";

interface CustomerRouteParams {
  materials?: any[];
  columns: any[];
  cols?: any;
  salesOrg?:any;
  recommended?: any[];
  onHover?: (material_num: string) => void;
  onDragReplace?: (old: any, toRepl: any) => void;
  onSelect?: (curr: any) => void;
  updateLayout?: (columns: any[]) => void;
  onSwap?: (old: any, toRepl: any) => void;
  onInsert?: (from: MaterialGridItem, to: MaterialGridItem, direction: "Left" | "Right") => void;
  onEditCapacity?: (index: any, capacity: number,toUpd?:any) => void;

  replacing?: any[];
  replaced?: any[];
  selected?: any;
  replacePtr?: number;
  applyRecommended?: boolean;
  columnmap?: any[];
  editCapacity?: boolean;
  key?: string;
  reco?: any[];

}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(0),
    },
    check: {
      position: "absolute",
      height: 20,
      width: 20,
      top: -80,
      left: 4,
      backgroundColor: "red",
    },
    gridMarginTop: {
      marginTop: theme.spacing(1),
    },
    imageProvider: {
      height: "60px",
      paddingTop: "0px",
    },
    typographyPad: {
      display: "inline-block",
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
    },
    typographyPadBot: {
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
    flex: {
      paddingTop: theme.spacing(1),
      display: "flex",
    },
  })
);

export function prepColumns(props: CustomerRouteParams, shouldMapBackToOld?: boolean) {
  let columns: any = [];
  if (props.applyRecommended && props.recommended) {
    props.recommended.forEach((q) => {
      if(props.reco){
        const matchingMaterial = props.reco.find(firstItem => 
          firstItem.material.material_num === q.material.material_num
      );
      if (matchingMaterial) {
          q.protected = matchingMaterial.protected;
      } else {
          q.protected = null; // Or any default value if not found
      }
      }
      columns.push({
        ...q,
        config_type: "C",
      });
    });
  } else {
    props?.columns?.forEach((q) => {
      columns.push({
        ...q,
        config_type: "R",
      });
    });
  }

  if (props.replaced) {
    props.replaced.forEach((q) => {
      let found = columns.find((v: any) => v.column_num === q.column_num);
      if (found) {
        found.modified = q.modified;
        found.swapped = q.swapped;
        found.column_capacity = q.material.capacity;
        found.material = {
          ...q.material,
        };
        // found.config_type = "O"
      }
    });

    let counts: { [key: string]: number } = {};

    for (let count of columns) {
      if (!counts[count.material.material_num]) {
        counts[count.material.material_num] = 1;
      } else {
        counts[count.material.material_num]++;
      }
    }

    for (let column of columns) {
      column.material.column_count = counts[column.material.material_num];
    }
  }

  if (shouldMapBackToOld) {
    let colsOld = props.cols.columns;

    for (let _i in colsOld) {
      let col = colsOld[_i];

      for (let columnInMachine of columns) {
        if (columnInMachine.column_num === col) {
          columnInMachine.column_num = _i;
          break;
        }
      }
    }
  }

  return columns;
}

function DraggableRender(
  props: any,
  theme: any,
  classes: any,
  v: MaterialGridItem,
  ipr: number,
  anythingDragged: boolean,
  setAnythingDragged: any,
  imageSrc: string | undefined,
  setImageSrc: any
) {
  const onHover = (mat: string) => {
  
    props.onHover && props.onHover(mat);
  };

  const onReplace = (old: any, upd: any) => {
    props.onDragReplace && props.onDragReplace(old, upd);
  };

  const onSelected = (curr: any) => {
    props.onSelect && props.onSelect(curr);
  };

  const onSwap = (curr: any, prop: any) => {
    props.onSwap && props.onSwap(curr, prop);
  };

  const onInsert = (from: MaterialGridItem, to: MaterialGridItem, direction: "Left" | "Right") => {
    props.onInsert && props.onInsert(from, to, direction);
  };

  const formatFill = (v: any) => {
    let tmp = v.material.capacity || v.max_fill;
    if (tmp) return `${v.column_num} / ${v.column_capacity ?? v.material.capacity}`;
    
    return `${v.column_num}`;
  };

  const editCapacity = props.editCapacity || false;

  const it = {
    ...v,
    id: v.column_num,
    type: "Material",
    src: `${BASE_URL}/api/images?clientId=${100}&materialnumber=${v.material.material_num}&salesOrg=${props.salesOrg}`,
  };

  const [{ isDragging }, drag, preview] = useDrag(() => ({
    item: it,
    type: "Material",
    options: {
      dropEffect: "default",
    },
    end: () => {
      setAnythingDragged(false);
    },
    collect: (monitor: any) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  preview(getEmptyImage(), { captureDraggingState: true });

  const [{}, dropTop] = useDrop(() => ({
    accept: "Material",
    drop: (item, monitor) => {
      onSwap(v, item);
      setAnythingDragged(false);
    },
    collect: (monitor: any) => ({
      isOver: !!monitor.isOver(),
    }),
    hover: () => {
      setImageSrc("/img/swap.svg");
    },
  }));

  const [{}, dropLeft] = useDrop(() => ({
    accept: "Material",
    drop: (item: MaterialGridItem, monitor) => {
      onInsert(item, v, "Left");
      setAnythingDragged(false);
    },
    hover: () => {
      setImageSrc("/img/loupe_black_24dp_l.svg");
    },
    collect: (monitor: any) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const [{}, dropRight] = useDrop(() => ({
    accept: "Material",
    drop: (item: MaterialGridItem, monitor) => {
      onInsert(item, v, "Right");
      setAnythingDragged(false);
    },
    hover: () => {
      setImageSrc("/img/loupe_black_24dp_r.svg");
    },
    collect: (monitor: any) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const [{}, dropBottom] = useDrop(() => ({
    accept: "Material",
    drop: (item, monitor) => {
      onReplace(v, item);
      setAnythingDragged(false);
    },
    hover: () => {
      setImageSrc("/img/copy.svg");
    },
    collect: (monitor: any) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  useEffect(() => {
    if (isDragging) setAnythingDragged(true);
  }, [isDragging]);

  const debug = false;
 function  getModifiedData(modified:any,swapped:any){
  if(swapped){
    return "dashed 2px"
  }else if(modified){
    return "solid 2px"
  }
return 'none';
 }

// edit capacity with block and unblock column
  const columnAction = (capacityNewVal: any,v:any) => {
  const matNum:any = v.material.material_num;
  let previous_mat:any = matNum;   let previous_mat_capacity:any = v.material.capacity;
    if(v.material.previous_mat){
      previous_mat = v.material.previous_mat;
      previous_mat_capacity = v.material.previous_mat_capacity;
    }
   if(capacityNewVal>0 && matNum ==="BLOCKED" && v.material.previous_mat){
        const upd = {
          ...v,
          material: {
            ...v.material,
            material_num: previous_mat,
            capacity:previous_mat_capacity,
            previous_mat:previous_mat,
            previous_mat_capacity:previous_mat_capacity
          },
          
        };
        props?.onEditCapacity(v, parseInt((capacityNewVal || "").toString()),upd)
    }else if(capacityNewVal>0 && matNum ==="BLOCKED" && !v.material.previous_mat){
      alert("Please choose a material to map for a blocked column ");
      props?.onEditCapacity(v, 0);
    }
    else if(capacityNewVal>0 && matNum !=="BLOCKED"){
          const upd = {
            ...v,
            material: {
              ...v.material,
              material_num: matNum ,
              capacity:capacityNewVal,
              previous_mat:previous_mat,
              previous_mat_capacity:previous_mat_capacity
            }
          };
          props?.onEditCapacity(v, parseInt((capacityNewVal || "").toString()),upd)
    }
    else{
      if(capacityNewVal==0){
        const upd = {
          ...v,
          material: {
            ...v.material,
            material_num: 'BLOCKED' ,
            capacity:0,
            eaches:0,
            previous_mat:previous_mat,
            previous_mat_capacity:previous_mat_capacity
          }
        };
        props?.onEditCapacity(v, parseInt((capacityNewVal || "").toString()),upd)
      } else {
        props?.onEditCapacity(v, parseInt((capacityNewVal || "").toString()))
      }
    } 
   };
  return (
    <div
      style={{
        display: "block",
        width: `${100.0 / ipr}%`,
      }}
    >
      <div
        key={`${props.key || "VendingVisualizer"}-div-${v.column_num}`}
        style={{
          display: "block",
          width: "100%",
        }}
        onClick={() => onSelected(v)}
        onMouseOver={() => {
          if (isDragging) return;
          onHover(v.material.material_num);
        }}
        onMouseLeave={() => onHover("")}
      >
        {isDragging && <CustomDragLayer overrideSrc={isDragging ? imageSrc : ""} />}
        <figure
          key={`${props.key || "VendingVisualizer"}-figure-${v.column_num}`}
          style={{
            margin: "6px auto",
            padding: 0,
            paddingTop: "5px",
            paddingLeft: "0px",
            paddingRight: "20px",
            textAlign: "center",
            borderRadius: "4px",
            position: "relative",
            width: "60%",
            height: 110,
            border: getModifiedData(v.modified,v.swapped),
            zIndex: 8,
            backgroundColor: !!props.replacing?.find(
              (x: any) => x.material.material_num === v.material.material_num && x.column_num === v.column_num
            )
              ? theme.palette.highlightRow.main
              : parseInt(props.selected) === parseInt(v.material.material_num)
              ? theme.palette.dhighlightRow.main
              : "transparent",
          }}
        >
          {anythingDragged && (
            <div>
              <div
                ref={dropLeft}
                style={{
                  backgroundColor: !debug ? "transparent" : "purple",
                  position: "absolute",
                  width: "calc(40% + 30px)",
                  top: 0,
                  left: -40,
                  height: "100%",
                  zIndex: 10,
                }}
              />
              <div
                ref={dropRight}
                style={{
                  backgroundColor: !debug ? "transparent" : "orange",
                  position: "absolute",
                  width: "calc(40% + 30px)",
                  top: 0,
                  left: "calc(70%)",
                  height: "100%",
                  zIndex: 10,
                }}
              />
              <div
                ref={dropTop}
                style={{
                  backgroundColor: !debug ? "transparent" : "blue",
                  position: "absolute",
                  width: "50%",
                  left: "25%",
                  top: 0,
                  height: "50%",
                  zIndex: 10,
                }}
              />
              <div
                ref={dropBottom}
                style={{
                  backgroundColor: !debug ? "transparent" : "green",
                  position: "absolute",
                  width: "50%",
                  left: "25%",
                  height: "50%",
                  top: "50%",
                  zIndex: 10,
                }}
              />
            </div>
          )}
          <div
            key={`${props.key || "VendingVisualizer"}-img-${v.column_num}`}
            style={{
              position: "absolute",
              height: 60,
              textAlign: "center",
              width: "100%",
              zIndex: 9,
            }}
            className={classes.imageProvider}
          >
            <img
              ref={drag}
              alt="tmp"
              style={{
                position: "relative",
                height: 60,
                margin: "0 auto",
                pointerEvents: "all",

                zIndex: 9,
              }}
              src={`${BASE_URL}/api/images?clientId=${100}&materialnumber=${v.material.material_num}&salesOrg=${props.salesOrg}`}
            />
          </div>

          <figcaption
            key={`${props.key || "VendingVisualizer"}-figcaption-${v.column_num}`} id={`${props.key || "VendingVisualizer"}-figcaption-${v.column_num}`}
            style={{
              position: "absolute",
              height: 60,
              top: 85,
              width: "100%",
              zIndex: 9,
            }}
          >
            {v?.material?.material_num?.replace("000000000000", "")}
          </figcaption>
          <figcaption
            style={{
              position: "absolute",
              height: 60,
              top: 70,
              width: "100%",
              zIndex: 9,
            }}
          >
            {formatFill(v)}
          </figcaption>
        </figure>
      </div>
      {editCapacity && (
        <div
        
          style={{
            margin: "auto",
            position: "relative",
            width: "60%",
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(2),
            zIndex: 500,
          }}
        >
          <TextField
            key={`${props.key || "VendingVisualizer"}-editCapacity-${v.column_num}`}
            label="Capacity"
            type="number"
            variant="outlined"
            defaultValue={v.material.capacity || 0}
            size="small"
            onBlur={(ce) =>columnAction(ce.target.value,v) }
            //onBlur={(ce) => props?.onEditCapacity(v, parseInt((ce.target.value || "").toString()))}
            onKeyDown={(ce: any) => {
              if (ce.key === "Enter") {
                columnAction(ce.target.value,v);
              }
            }}
            InputProps={{
        inputProps: { 
            max: 999, min: 0 
        }
    }}
          />
        </div>
      )}
    </div>
  );
}

export default function VendingVisualizer(props: CustomerRouteParams) {
  let columns = prepColumns(props);

  const theme = useTheme();
  const classes = useStyles();
  const [anythingDragged, setAnythingDragged] = useState<boolean>(false);
  const [imageSrc, setImageSrc] = useState<string>("");
  const toggleSetAnythingDragged = (bool: boolean) => setAnythingDragged(bool);
  const setImageSource = (str: string) => setImageSrc(str);

  return (
    <div className={classes.root}>
      <div style={{ display: "flex" }} className={classes.gridMarginTop}>
        <Grid container>
          {columns.map((v: any) =>
            DraggableRender(
              props,
              theme,
              classes,
              v,
              props?.cols?.items_per_row,
              anythingDragged,
              toggleSetAnythingDragged,
              imageSrc,
              setImageSource
            )
          )}
        </Grid>
      </div>
    </div>
  );
}
